// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_aj-3";
export var contentContainer = "_aj-0";
export var editorContainer = "_aj-1";
export var quillInputForm = "_aj-2";
export var zoneDivider = "_aj-4";